module.exports = {
    title: 'About',
    excerpt: {
        role: 'UX Engineer',
        company: 'Google',
        location: 'San Francisco',
        greetings: "Hi there! I'm Michel Comin.",
        workingAs: "I'm currently working as",
        livingIn: "And I'm enjoying life in",
    },
    content: [
        "I have always been deeply interested in technology and how the audiovisual world meets technology and art. That's why I became a Telecommunications Engineer, majoring in Image and Sound Processing.",
        "For almost 6 years I worked as a Creative Technologist, which enabled me to work on a wide variety of project. On those, I was able to be a part of the team that was conceiving an idea, to prototype the interactions and concepts, and to deploy the actual project. This enabled me to get the most out of the latest technologies. Currently, I'm working as a UX Engineer.",
        "In my spare time, I like to focus on creative coding, especially computer graphics. Additionally, I love music and photography. And I'm so lucky because I have another project called Mindies, a website about indie music where I'm in charge of taking pictures of gigs and festivals, reviewing new albums, writing music news and so on.",
    ],
    resumeLink: '/resume.pdf',
    resume: 'Resume',
};



// WEBPACK FOOTER //
// ./content/pages/about.js